import { createBackend } from '@/utils/request'
export default createBackend(process.env.VUE_APP_BASE_API_2);